/** True when the bar has a non-deleted reservation linked to a job/part. */
export function lengthHasPartAssignment(len: any): boolean {
	const reservations = len?.material_reservations ?? [];
	return reservations.some((r: any) => {
		if (r?.deleted) return false;
		const oli = r?.order_line_item;
		return oli != null && oli !== '';
	});
}
